import React from 'react';
import PDFViewer from '../Common/PDFViewer/PDFViewer';
import LoginHeader from '../Common/LoginHeaderWhite/LoginHeaderWhite';
import config from '../../config.json';
import './TermsOfUse.css';
const termsOfUsePDF = `${config.SERVER_URL_IMG}media/files/TermsOfUse.pdf`;

export default function TermsOfUse() {
    return (
        <>
            <LoginHeader isDarkLogo enrollButtonText="ENROLL" />
            <div className="terms-title">
                <h3 className="heading-3">Terms of Use</h3>
            </div>
            <div className="all-page-container">
                <PDFViewer pdf={termsOfUsePDF} />
            </div>
        </>
    );
}
